import React from 'react';
import { Link } from '@wikom/wikom-router';
import { useRoute } from '@app/router';
import Navbar from './Navbar';
var GuestNavigation = function () {
    var ROUTE = useRoute();
    return (React.createElement(Navbar, { name: "navbar", containerFluid: false, className: "navbar-inverse navbar" },
        React.createElement("li", null,
            React.createElement("a", { href: "/" }, "Startseite")),
        React.createElement("li", null,
            React.createElement(Link, { to: ROUTE.PAGE.COMMON.CONTACT() }, "Kontakt"))));
};
export default GuestNavigation;
